import { PropsWithChildren } from 'react';

import { MantineProvider, useMantineTheme } from '@mantine/core';

import { AuthProvider as BaseAuthProvider, ProtectedWithAuth } from '@/shared/auth';

import { Root } from './Root';
import { THEME } from './theme';

function AuthProvider({ children }: PropsWithChildren) {
  const theme = useMantineTheme();

  return (
    <BaseAuthProvider theme={theme} clientId={process.env.PUBLIC_OIDC_CLIENT_ID!}>
      {children}
    </BaseAuthProvider>
  );
}

export function App() {
  return (
    <MantineProvider theme={THEME}>
      <AuthProvider>
        <ProtectedWithAuth>
          <Root />
        </ProtectedWithAuth>
      </AuthProvider>
    </MantineProvider>
  );
}
